module.exports = __webpack_public_path__ + "static/media/logo.f67a799c.png";